export default {
  categories_format(categories) {
    let output = {};

    categories.forEach((item) => {
      output[item.id] = item;
    });

    return output;
  },

  with_products(categories, products) {
    const reducer = (item) => {
      if (item && item.products)
        item.products = item.products
          .map((id) => products.find((product) => product.id == id))
          .filter((filterd) => filterd);

      if (item && item.children && item.children.length)
        item.children = item.children.map((inside_item) =>
          reducer(inside_item)
        );
      return item;
    };

    let output = categories.reduce((acc, current) => {
      const replaced = reducer(current);
      acc.push(replaced);
      return acc;
    }, []);

    return output;
  },
};
